<template>
  <ul class="nt-menuvertical">
    <li v-for="(item, index) in items" v-bind:key="item.id">
      <nt-vertical-menu-item 
        :item="item" 
        :position="++index"
        :selected="selected"
      >
      </nt-vertical-menu-item>
    </li>
  </ul>
</template>

<script>
  import NtVerticalMenuItem from './nt-vertical-menu-item.vue'

  export default {
    name: 'NtVerticalMenu',
    data() {
      return {
        selected: null
      }
    },
    watch: {
      selected(value) {
        window.console.log(`selected => ${JSON.stringify(value)}`)
      }
    },
    props: {
      items: {
        type: Array,
        default: []
      }
    },
    created() {
      this.$root.$on('changeVerticalMenu', this.onChangeItem)
    },
    methods: {
      onChangeItem(item) {
        this.selected = item
      }
    },
    components: {
      NtVerticalMenuItem
    }
  }
</script>
